"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DfnsApiClient = void 0;
const Assets_1 = require("./codegen/Assets");
const Auth_1 = require("./codegen/Auth");
const Blockchains_1 = require("./codegen/Blockchains");
const Callbacks_1 = require("./codegen/Callbacks");
const Permissions_1 = require("./codegen/Permissions");
const PolicyExecution_1 = require("./codegen/PolicyExecution");
const PolicyManagement_1 = require("./codegen/PolicyManagement");
const PublicKeys_1 = require("./codegen/PublicKeys");
const permissions_1 = require("./generated/permissions");
const policies_1 = require("./generated/policies");
const signers_1 = require("./generated/signers");
const wallets_1 = require("./generated/wallets");
const webhooks_1 = require("./generated/webhooks");
class DfnsApiClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    get assets() {
        return new Assets_1.AssetsClient(this.apiOptions);
    }
    get auth() {
        return new Auth_1.AuthClient(this.apiOptions);
    }
    get blockchains() {
        return new Blockchains_1.BlockchainsClient(this.apiOptions);
    }
    get callbacks() {
        return new Callbacks_1.CallbacksClient(this.apiOptions);
    }
    /**
     * @deprecated use permissions v2 instead
     */
    get permissions() {
        return new Permissions_1.PermissionsClient(this.apiOptions);
    }
    get permissionsV2() {
        return new permissions_1.PermissionsClient(this.apiOptions);
    }
    get policies() {
        return new policies_1.PoliciesClient(this.apiOptions);
    }
    /**
     * @deprecated use the new policy engine instead
     */
    get policyExecution() {
        return new PolicyExecution_1.PolicyExecutionClient(this.apiOptions);
    }
    /**
     * @deprecated use the new policy engine instead
     */
    get policyManagement() {
        return new PolicyManagement_1.PolicyManagementClient(this.apiOptions);
    }
    get publicKeys() {
        return new PublicKeys_1.PublicKeysClient(this.apiOptions);
    }
    get wallets() {
        return new wallets_1.WalletsClient(this.apiOptions);
    }
    get webhooks() {
        return new webhooks_1.WebhooksClient(this.apiOptions);
    }
    get signers() {
        return new signers_1.SignersClient(this.apiOptions);
    }
}
exports.DfnsApiClient = DfnsApiClient;
